import D_Number from '@utils/number';

const formatOtherCountriesInBranches = function (otherCountries) {
  if (otherCountries.length > 5) {
    return `Various (${otherCountries.length} countries)`;
  }
  if (otherCountries.length === 0) {
    return '-';
  }
  const text = otherCountries.map((country, index) => {
    const dot = index === otherCountries.length - 1 ? `` : `, `;
    return `${country.countryName}(${country.branchesCount})${dot}`;
  });
  return `${text.join('')}`;
};

const formatEmployeeNumber = (number) =>
  number === null ? '-' : D_Number.addSeparator(number);

const formatSalesAmount = (number) =>
  number === null
    ? '-'
    : `$${D_Number.addSeparator((number / 1000).toFixed(0))}K`;

export const SharedTooltip = (that) => `<div class="le-tooltip shared">
<div class="shared">
  <div class="le-title">${that.point.others.buyer.companyName}</div>
  <div class="country-name">${that.point.others.buyer.countryName}</div>
  Subsidiaries: <b>${
    D_Number.addSeparator(that.point.others.buyer.subsidiariesNumber) || '-'
  }</b>
  <br/>
  Branches: <b>${
    D_Number.addSeparator(that.point.others.buyer.branchesNumber) || '-'
  }</b>
  <br/>
  Employees: <b>${formatEmployeeNumber(
    that.point.others.buyer.employeesNumber,
  )}</b>
  <br/>
  Sales: <b>${formatSalesAmount(that.point.others.buyer.salesAmount)}</b>
  <br/>
  Branches also in: 
  <br/>
  <b>${formatOtherCountriesInBranches(
    that.point.others.buyer.otherCountries,
  )}</b>
</div>
<div class="divide-line"></div>
<div class="shared">
  <div class="le-title">${that.point.others.target.companyName}</div>
  <div class="country-name">${that.point.others.target.countryName}</div>
  Subsidiaries: <b>${
    D_Number.addSeparator(that.point.others.target.subsidiariesNumber) || '-'
  }</b>
  <br/>
  Branches: <b>${
    D_Number.addSeparator(that.point.others.target.branchesNumber) || '-'
  }</b>
  <br/>
  Employees: <b>${formatEmployeeNumber(
    that.point.others.target.employeesNumber,
  )}</b>
  <br/>
  Sales: <b>${formatSalesAmount(that.point.others.target.salesAmount)}</b>
  <br/>
  Branches also in: 
  <br/>
  <b>${formatOtherCountriesInBranches(
    that.point.others.target.otherCountries,
  )}</b>
</div>
</div>`;

export const SingleSideTooltip = (that) => `<div class="le-tooltip">
  <div class="le-title" style='background-color:${that.color};color:${
  that.color === '#FFB600' ? '#000000' : '#ffffff'
}'>${that.point.others.companyName}</div>
  <div class="country-name">${that.point.others.countryName}</div>
  Subsidiaries: <b>${
    D_Number.addSeparator(that.point.others.subsidiariesNumber) || '-'
  }</b>
  <br/>
  Branches: <b>${
    D_Number.addSeparator(that.point.others.branchesNumber) || '-'
  }</b>
  <br/>
  Employees: <b>${formatEmployeeNumber(that.point.others.employeesNumber)}</b>
  <br/>
  Sales: <b>${formatSalesAmount(that.point.others.salesAmount)}</b>
  <br/>
  Branches also in: 
  <br/>
  <b>${formatOtherCountriesInBranches(that.point.others.otherCountries)}</b>
  </div>`;

export const PointTooltip = (that) =>
  `<div class="le-tooltip">
    <div class="le-title" style='background-color:${
      that.point.others.color
    };color:${
    that.point.others.color === '#FFB600' ? '#000000' : '#ffffff'
  };'>${that.point.others.companyName}</div>
    <div class="country-name">${that.point.others.countryName}</div>
    City: <b style="width:12.5rem">${that.point.others.city}</b>
    <br/>
    Address: <b>${that.point.others.address}</b>
  `;
